import React, { useRef, useState } from "react";
import "./Guestbook.css";
import SignatureCanvas from "react-signature-canvas";

import { SuccessToast } from "../../toast/SuccessToast";
import { UndoStrokeIcon, XIcon } from "../../icons/SvgIcons";
import { useGuest } from "../../../contexts/GuestContext";
import { SpinnerOverlay } from "../../spinner/SpinnerOverlay";
import { getToken } from "firebase/app-check";
import { appCheck } from "../../../firebase/firebase";

export const Guestbook = () => {
  const sigCanvas = useRef<any>(null);
  const [hasSignature, setHasSignature] = useState(false);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const { token: contextToken } = useGuest();
  const token = contextToken || "anonymous";
  const [errors, setErrors] = useState<{
    name: boolean;
    message: boolean;
    signature: boolean;
  }>({
    name: false,
    message: false,
    signature: false,
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const signatureData = sigCanvas.current?.toDataURL("image/png");
    const emptySignature = !signatureData || sigCanvas.current.isEmpty();
    const newErrors = {
      name: name.trim() === "",
      message: message.trim() === "",
      signature: emptySignature,
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some(Boolean)) return;
    setLoading(true);

    try {
      const { token: appCheckToken } = await getToken(appCheck, true);
      const res = await fetch(
        "https://us-central1-wedding-bca0e.cloudfunctions.net/submitGuestEntry",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Firebase-AppCheck": appCheckToken,
          },
          body: JSON.stringify({
            token,
            name: name.trim(),
            message: message.trim(),
            signatureDataUrl: signatureData,
          }),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Error desconocido");

      setToastOpen(true);
      setName("");
      setMessage("");
      clearSignature();
    } catch (error: any) {
      console.error("Error al guardar:", error);
      alert(
        error.message === "Too many requests"
          ? "Ya enviaste tu firma hace poco, intenta más tarde."
          : "Ocurrió un error al guardar tu firma. Intenta más tarde"
      );
    } finally {
      setLoading(false);
    }
  };

  const clearSignature = () => {
    sigCanvas.current.clear();
    setHasSignature(false);
  };

  const handleUndo = () => {
    const pad = sigCanvas.current?.getSignaturePad();
    if (!pad) return;

    const data = pad.toData();
    if (data.length === 0) return;

    data.pop();
    pad.clear();
    pad.fromData(data);

    setHasSignature(!pad.isEmpty());
  };
  return (
    <>
      {loading && <SpinnerOverlay />}
      <section className="book-section">
        <div className="book-title-stack">
          <p className="book-title-main">Libro de</p>
          <span className="book-title-fancy">firmas</span>
        </div>

        <p className="book-subtitle">
          Tus palabras hacen este día aún más especial...
        </p>

        <form className="book-form" onSubmit={handleSubmit}>
          <label>
            Nombre(s):
            <input
              type="text"
              className="book-input"
              placeholder="—"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {errors.name && (
              <span className="book-error">Este campo es obligatorio</span>
            )}
          </label>

          <label>
            Tus palabras:
            <textarea
              className="book-textarea"
              placeholder="—"
              value={message}
              rows={3}
              onChange={(e) => setMessage(e.target.value)}
            />
            {errors.message && (
              <span className="book-error">Este campo es obligatorio</span>
            )}
          </label>

          <label>Déjanos tu firma o un lindo dibujo</label>
          <div className="signature-wrapper">
            <SignatureCanvas
              penColor="#8c906c"
              backgroundColor="#f9f9f5"
              clearOnResize={false}
              canvasProps={{
                className: "signature-canvas",
                // width: 500, height: 200
              }}
              onEnd={() => {
                if (!sigCanvas.current?.isEmpty()) {
                  setHasSignature(true);
                }
              }}
              ref={sigCanvas}
            />
            {errors.signature && (
              <span className="book-error">La firma es obligatoria</span>
            )}
            {hasSignature && (
              <>
                <span className="clear-canvas-x" onClick={clearSignature}>
                  <XIcon fill={"#8c906c"} />
                </span>

                <span className="undo-stroke-button" onClick={handleUndo}>
                  <UndoStrokeIcon width="20" height="20" />
                </span>
              </>
            )}
          </div>

          <button className="book-button" type="submit" disabled={loading}>
            Firmar
          </button>
        </form>

        <div className="moments-container">
          <div className="moments-title-stack">
            <p className="moments-title-main">Share your</p>
            <span className="moments-title-fancy">moments</span>
          </div>
          <p className="moments-subtitle">
            Y aún más especiales los momentos compartidos contigo en nuestra
            boda
          </p>
          <div className="moments-button-wrapper">
            <a
              href="https://photos.app.goo.gl/5r5DbWY1uiyvd37XA"
              className="moments-button"
              target="_blank"
            >
              Cargar fotos y videos
            </a>
          </div>
        </div>
      </section>
      <SuccessToast
        open={toastOpen}
        onOpenChange={setToastOpen}
        message="¡Gracias por tu mensaje y firma!"
      />
    </>
  );
};
